class customSorting extends HTMLElement {
    constructor() {
      super();

      const sectionId = document.querySelector(".collection-content").getAttribute('data-section-id');
      this.section = {
        sectionId,
        nodeId: "CollectionAjaxContent"
      }

      this.ajaxCollectionEl = document.querySelector(`#${this.section.nodeId}`);
     
      this.init();

      document.addEventListener("removeSorting", () => {
        this.removeSorting();
      });
    };

    init() {
        const self = this;
        this.sortItems = this.querySelectorAll("[js-sort-item]");

        this.sortItems.forEach( item => {
          item.addEventListener('click', function() {
            const sortHandle = this.dataset.sortValue;
            self.initAjaxCollection(sortHandle, this);
          })
        });
    };

    initAjaxCollection(sortHandle, targetEl) {
        this.changeActiveState(targetEl);
        this.updateHistoryState(sortHandle);
        this.renderAjaxCollection();
    };

    changeActiveState(targetEl) {
        this.sortItems.forEach( item => item.classList.remove("selected"));
        targetEl.classList.add('selected');
    };

    updateHistoryState(sortHandle) {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("sort_by", sortHandle);
        const newurl = searchParams;

        history.pushState({},'',`${'?'.concat(newurl)}`);
    };

    removeSorting() {
        this.classList.remove("is-open");
        this.sortItems.forEach( item => item.classList.remove("selected"))
    }

    renderAjaxCollection() {
        const self = this;
        let url = `${window.location.pathname}${window.location.search}&section_id=${this.section.sectionId}`;

        fetch(url).then(function(response) {
            return response.text();
        }).then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            self.classList.remove("is-open");

            self.ajaxCollectionEl.innerHTML = doc.querySelector(`#${self.section.nodeId}`).innerHTML;

            document.dispatchEvent(new CustomEvent('dropdown:init'));
            self.init.bind(self);

            //console.log('quickAdd', typeof quickAdd);
            if(typeof quickAdd != undefined) {
              quickAdd();
            }
        });
    }
}
  
customElements.define('custom-sorting', customSorting);
  
  